<template>
  <swiper :options="swiperOption" ref="mySwiper">
    <slot><!-- include swiper-slide --></slot>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
export default {
  data () {
    return {
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="scss">
.swiper-button-next {
  right: 3vw;
	background-image: url(/images/arrow_next.png) !important;
}

.swiper-button-prev {
  left: 3vw;
	background-image: url(/images/arrow_prev.png) !important;
}

.swiper-button-next,
.swiper-button-prev {
	width: 15px;
	height: 37px;
  background-size: 100%;
  margin-top: 0;
}
</style>